import React from "react";

import { Grid } from "@/components/Grid";
import { StyledIconWrapper, Icon } from "@/components/Icon";
import { Image } from "@/components/Image";
import { useTheme } from "@/hooks/useTheme";

export const TerminalImagesSection: React.FC = () => {
  const { colors, bp } = useTheme();

  const commonImageStyles = {
    maxWidth: 600,
    width: "100%",
    borderRadius: 8,
    boxShadow: `12px 8px 20px 0 ${colors.CETACEAN_BLUE}`,
  };

  return (
    <>
      <Grid
        id="TerminalImagesSection"
        customStyle={{
          flexDirection: "column",
          alignItems: "center",
          [bp.FROM_DESKTOP]: {
            flexDirection: "row",
            justifyContent: "space-between",
            alignItems: "flex-start",
            position: "relative",
            height: 737,
          },
        }}
        wrapperStyle={{ backgroundColor: colors.LIGHT_GRAY2 }}
      >
        <Image
          src="/images/terminal-image.jpg"
          alt="Converter Request API"
          customStyle={{
            ...commonImageStyles,
            [bp.FROM_DESKTOP]: {
              maxWidth: 701,
              transform: "translateX(125px)",
            },
          }}
        />
        <StyledIconWrapper
          wrapperStyle={{
            width: 60,
            height: 60,
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            position: "relative",
            borderRadius: "50%",
            backgroundColor: colors.WHITE,
            boxShadow: `12px 8px 20px 0 ${colors.CETACEAN_BLUE}`,
            transform: "rotate(90deg)",
            margin: 30,
            [bp.FROM_DESKTOP]: {
              position: "absolute",
              alignSelf: "center",
              flexShrink: 0,
              transform: "none",
              left: "31%",
              top: "33%",
            },
          }}
        >
          <Icon iconType="ARROW-RIGHT-GREY" />
        </StyledIconWrapper>
        <Image
          src="/images/api-response-image.jpg"
          alt="Converter Request API"
          customStyle={{
            ...commonImageStyles,
            [bp.FROM_DESKTOP]: {
              order: 1,
              transform: "translate(-125px, 110px)",
            },
          }}
        />
      </Grid>
    </>
  );
};
